import { IMessageBarStyles, IStackStyles } from "@fluentui/react";
import React from "react";

import { FailureSeverity, ValidationResult } from "../../utils/validation/ValidationResult";
import { Stack } from "../layouts/stack/Stack";
import { Spinner } from "../progress/Spinner";
import { FormFailureMessages } from "./FormFailureMessages";

interface FormValidationSummaryProps {
    styles?: IMessageBarStyles;
    validationResult: ValidationResult | undefined;
    isDetached?: boolean;
    isValidating?: boolean;
    isVertical?: boolean;
    renderCustomMessage?(groupedFailures: Map<string, string[]>, item: string): JSX.Element | undefined;
}

export const FormValidationSummary: React.FC<FormValidationSummaryProps> = ({
    styles,
    validationResult,
    isDetached,
    isValidating,
    isVertical,
    renderCustomMessage
}: FormValidationSummaryProps) => {
    const failures = validationResult?.failures ?? [];

    return (
        <Stack styles={isDetached ? detachedStyles : undefined}>
            {isValidating && <Spinner />}
            {!isValidating && (
                <>
                    <FormFailureMessages
                        styles={styles}
                        failures={failures}
                        severity={FailureSeverity.Error}
                        isVertical={isVertical}
                        testId="form-validation-error-message"
                        renderCustomMessage={renderCustomMessage}
                    />
                    <FormFailureMessages
                        styles={styles}
                        failures={failures}
                        severity={FailureSeverity.Warning}
                        isVertical={isVertical}
                        testId="form-validation-warning-message"
                        renderCustomMessage={renderCustomMessage}
                    />
                </>
            )}
        </Stack>
    );
};

const detachedStyles: IStackStyles = {
    root: { padding: 10, paddingTop: 30 }
};
